export const sparkbill_oauth = "sparkbill-oauth";
